export enum StickerPosition {
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  FULL_LEFT='FULL_LEFT',
  FULL_RIGHT='FULL_RIGHT',
  NONE = 'NONE'
}
